import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { SupportPrincipalService } from '../auth/support-principal.service';

// NOTE: intentionally not annotated `: CanActivateFn` — that type's `route`/`state`
// params are non-optional, so a `CanActivateFn`-typed const requires callers to pass
// both. Angular's `canActivate: [...]` route config still accepts a zero-arg function
// (JS/TS parameter-count contravariance), and the specs call it with no args.
//
// This guard no longer initiates a login itself. Before the partner rail it WAS the
// sign-in entry point (it called MsalService.loginRedirect straight into the workforce
// tenant), which left VARs no way in. Sign-in now lives on the /login page (staff and
// partner rails, each choosing its own MSAL instance). The guard's only job: allow a
// signed-in principal (EITHER rail — SupportPrincipalService.isSignedIn checks both),
// and send everyone else to /login. `/login` is unguarded, so this cannot loop.
export const authenticatedGuard = (): boolean => {
  const principal = inject(SupportPrincipalService);
  const router = inject(Router);

  if (principal.isSignedIn()) {
    return true;
  }

  router.navigate(['/login']);
  return false;
};
